import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserCollectionAlbum } from '../user-collection-album.model';

@JsonObject('UserCollectionAlbumsResultsResponse')
export class UserCollectionAlbumsResultsResponse extends ApiResultsResponse<UserCollectionAlbum> {

  @JsonProperty('results', [UserCollectionAlbum])
  override results: UserCollectionAlbum[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
